import enquire from 'enquire.js'
import Component from '../core/Component'
import { queries } from '../core/config'
import throttle from 'lodash/throttle'
import { queryAll } from '../utils/dom'

export default class ProductCard extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            inner: null,
            sizeList: null,
            sizeLinks: []
        }

        this.isDesktop = true

        this.enquireHandler = {
            match: () => this.isDesktop = true,
            unmatch: () => this.isDesktop = false
        }

        this.handleResize = throttle(::this.handleResize, 100)
    }

    prepare() {
        if (!this.ref.sizeList) {
            return
        }

        this.ref.sizeLinks.forEach(element => element.href = element.getAttribute('href').replace('#', '?'))

        enquire.register(queries.mediumUp, this.enquireHandler)
        window.addEventListener('resize', this.handleResize)
        this.resize()
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler)
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize() {
        this.resize()
    }

    handleMouseEnter = event => {
        if (this.isDesktop) {
            this.ref.inner.style.transform = `translate3d(0, ${-this.ref.sizeList.getBoundingClientRect().height}px, 0)`
        }
    }

    handleMouseLeave = event => {
        if (this.isDesktop) {
            this.ref.inner.style.transform = `translate3d(0, 0, 0)`
        }
    }

    resize = () => {
        if (this.isDesktop) {
            this.ref.sizeList.style.marginBottom = `${-this.ref.sizeList.getBoundingClientRect().height}px`
        } else {
            this.ref.sizeList.style.marginBottom = '0px'
        }
    }
}